import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { useAuthStore } from '../../store/AuthContext';
import { useAppStore } from '../../store/AppContext';
import NoData from '../../components/NoData';
import { PriceFormatter } from '../../utils/PriceFormatter';

type Props = {
  data: SaldoData[];
};

interface SaldoData {
  fecha: string;
  concepto: string;
  importe: number;
}

const CustomPaginationTable: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const options = {
    page: 1,
    sizePerPage: 20,
    pageStartIndex: 1,
  };
  const dataUser = useAuthStore();
  const dataApp = useAppStore();
  const { moneda } = dataUser.user;

  const priceFormatter = (cell: any) => {
    const monedaText = moneda === 'euro' ? t('euro') : t('cc');
    return PriceFormatter.formatStringAsPrice(cell as string, monedaText);
  };

  const dateFormatter = (cell: any) => {
    if (dataApp.lang === 'eu') {
      return moment(cell, 'DD/MM/YYYY').format('YYYY/MM/DD');
    }
    return cell;
  };
  const columnClassNameFormat = (fieldValue: number) => {
    const reg = new RegExp(/^-/);

    // fieldValue is column value
    // row is whole row object
    // rowIdx is index of row
    // colIdx is index of column

    return !reg.test(fieldValue.toString())
      ? 'td-importe-saldo td-importe-saldo-positivo'
      : 'td-importe-saldo ';
  };
  return (
    <>
      {(() => {
        if (data.length > 0) {
          return (
            <BootstrapTable data={data} options={options}>
              <TableHeaderColumn
                dataField="fecha"
                isKey
                className="th-fecha-saldo"
                columnClassName="td-fecha-saldo"
                dataFormat={dateFormatter}
              >
                {t('saldo.date')}
              </TableHeaderColumn>
              <TableHeaderColumn dataField="concepto">
                {t('saldo.concept')}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="importe"
                className="th-importe-saldo"
                columnClassName={columnClassNameFormat}
                dataFormat={priceFormatter}
              >
                {t('saldo.amount')}
              </TableHeaderColumn>
            </BootstrapTable>
          );
        }
        return (
          <NoData>
            <div className="mensaje">
              <p>{t('saldo.noRecords')}</p>
            </div>
          </NoData>
        );
      })()}
    </>
  );
};

export default CustomPaginationTable;
